import {Icon} from 'leaflet';
import objectFitImages from 'object-fit-images';
import AboutUs from './about-us';
import Contact from './contact';
import Gamme from './gamme';
import Home from './home';

const $ = window.jQuery;

objectFitImages();

// Fix Leaflet default icon path
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

$(() => {

    let $body = $(document.body);

    if ($body.hasClass('home')) {

        new Home();
        $('.header nav li.menu-products-solutions').removeClass('active');
        setTimeout(function () {
            if ($(window).scrollTop() === 0) {
                scrollToElement('section.services .bloc ul.list', 1500);
            }
        }, 3500);

        if($(window).width() < 1024){
            $('section.services .bloc ul.list li.single').click(function(){
                scrollToElement('section.services .bloc.list-illus', 600);
            });
        }
    }

    if ($body.hasClass('archive') ||
        $body.hasClass('page-template-gamme') ||
        $body.hasClass('page-template-downloads') ||
        $body.hasClass('product-template-default')) {
        new Gamme();
    }
    if ($body.hasClass('archive')) {
        $('.header nav li.menu-products-solutions').addClass('active');
        if($(window).width() < 1024){
            scrollToElement('div.row.detail-part', 600);
        };


    }
    if ($body.hasClass('single-product')) {
        $('.header nav li.menu-products-solutions').addClass('active');
        if($(window).width() < 1024){
            scrollToElement('div.row.detail-part', 600);
        };
    }

    if ($body.hasClass('page-template-contact')) {
        new Contact();
        if ($('p.status').length > 0) {
            scrollToElement('.status', 600);
        }
    }

    if ($body.hasClass('page-template-about-us')) {
        new AboutUs();

        /**
         * Animation ancres
         */
        $('section.process .filter-part ul li a').click(function () {
            scrollToElement($(this).attr('href'), 600);
        });

    }

    $('.header-nav li.menu-products-solutions a').click(function (e) {
        $('.header nav li.menu-home').removeClass('active');
        $('.header nav li.menu-products-solutions').addClass('active');
        scrollToElement('section.services .bloc ul.list', 600);
    });

    if (window.location.hash == '#products') {
        scrollToElement('section.services .bloc ul.list', 600);
        $('.header nav li.menu-home').removeClass('active');
        $('.header nav li.menu-products-solutions').addClass('active');
    }

    $('body.tax-product_range section.presentation .detail-part .border .content .sous-gamme-part ul.list-sg > li .arrow .hover').each(function () {
        let p = $(this).parent().position();
        $(this).css('left', $('.detail-part .border .content .sous-gamme-part ul.list-sg').width() + 10);
        $(this).css('width', $('.detail-part .border .content .sous-gamme-part ul.list-sg').innerWidth() + 12);
        $(this).css('top', -p.top + 20);
    });

    /* Partie mobile tablette */
    $('.menu-mobile').click(function () {
        $(this).toggleClass('actif');
        $('header .header-nav').slideToggle(300);
    });

    $('.toggle-tarte').click(() => {
        tarteaucitron.userInterface.openPanel();
    });

    /**
     * [scrollToElement description]
     * @param  {[type]} elt [description]
     * @return {[type]}     [description]
     */
    function scrollToElement(elt, duree) {
        $('html, body').animate({
            scrollTop: ($(elt).offset().top - $('header.header').height()),
        }, duree);
    }

});
